export default __webpack_public_path__ + "static/media/42.38248562.png";